module.exports = __webpack_public_path__ + "static/media/2day@2x.f58344e9.png";